import React from "react";
import { Image } from '../../../ui';
import styles from './quotation-item.module.scss';
import PropTypes from 'prop-types';
import { SmallSection } from "../../design";
const QuotationDetailsSection = ({ detail, comment }) => {
    return (
        <div className={styles.wrapper}>
            <div className={styles.left}>
                <div className={styles.image}>
                    {detail.item.product.main_photos && <Image src={`https://leoprinting.nl/files/photos/${detail.item.product.main_photos[0]}`}
                    />}
                </div>
                <p className={styles.imageTag}>Image is for illustration.Real product may vary</p>
            </div>
            <div className={styles.right}>

                <h3>Specifications :</h3>
                <div className={styles.specifications}>

                    {detail.specifications.map(({ name, value }) => (
                        <React.Fragment key={name}>
                            <div className={styles.name}>{name}</div>
                            <div className={styles.value}>{value}</div>
                        </React.Fragment>
                    ))}
                    {detail.item_hidden_specifications.map(({ name, value }) => (
                        <React.Fragment key={name}>
                            <div className={styles.name}>{name}</div>
                            <div className={styles.value}>{value}</div>
                        </React.Fragment>
                    ))}
                </div>

                {comment && <i><b>Comment from Leoprinting :</b> {comment}</i>}
            </div>
        </div>
    );
}

QuotationDetailsSection.propTypes = {
    detail: PropTypes.object.isRequired,
    comment: PropTypes.string
}
export default QuotationDetailsSection


export const CombiQuotationDetailsSection = ({ detail, comment }) => {
    return (
        <div className={styles.wrapper}>
            <div className={styles.left}>
                <div className={styles.image}>
                    {detail.item.product.main_photos && <Image src={`https://leoprinting.nl/files/photos/${detail.item.product.main_photos[0]}`}
                    />}
                </div>
                <p className={styles.imageTag}>Image is for illustration.Real product may vary</p>
            </div>
            <div className={styles.right}>
                <h3>Specifications :</h3>
                <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
                    {detail.specifications.map(({ data, quantity, item_id, countries }) => (
                        <SmallSection key={item_id} header={(
                            <div>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <div className="">Quantity : {quantity}</div>
                                    <div className="">Item Id : {item_id}</div>
                                </div>
                                <p>Countries : {countries.filter((value, index, array) => array.indexOf(value) === index).toString()}</p>
                            </div>

                        )}>
                            <h4>Specifications</h4>
                            <div>
                                {data.map(({ id, name, value }) => (
                                    <div key={id}><strong>{name} </strong>: {value}</div>
                                ))}
                            </div>
                        </SmallSection>
                    ))}
                </div>
                {comment && <i><b>Comment from Leoprinting :</b> {comment}</i>}
            </div>
        </div>
    );
}

CombiQuotationDetailsSection.propTypes = {
    detail: PropTypes.object.isRequired,
    comment: PropTypes.string
}